const text1 = document.getElementById('embroidery_add');
const text2 = document.getElementById('embroidery_text');
if (!text1 || !text2) return;
const checkboxWrapper = document.querySelector(
  '.product-embroidery .form-field__checkbox'
);
const inputError = document.querySelector('[data-embroidery-error]');
const ERROR_VISIBLE_MS = 2000;
let errorTimer = null;

/**
 * Allow-list: Latin letters (including accented ones such as æ ø å ä ö ü é)
 * and spaces, the only characters the embroidery machine can stitch.
 * Everything else is stripped: digits, punctuation, symbols, other scripts
 * (Cyrillic, Greek, Arabic, CJK, ...), emoji, joiners, < > and nulls.
 */
const disallowedRegex = /[^\p{Script=Latin} ]/gu;

text2.addEventListener('input', () => handleInput());
text1.addEventListener('change', () => copyTextValue());

/** Normalises accents to precomposed form, then removes every disallowed character. */
function sanitizeEmbroideryText(value) {
  return value.normalize('NFC').replace(disallowedRegex, '');
}

function hasDisallowedCharacters(value) {
  return sanitizeEmbroideryText(value) !== value.normalize('NFC');
}

function showInputError() {
  if (!inputError) return;
  inputError.classList.add('is-expanded');
  clearTimeout(errorTimer);
  errorTimer = setTimeout(() => {
    inputError.classList.remove('is-expanded');
  }, ERROR_VISIBLE_MS);
}

function copyTextValue(e) {
  const text2Value = text2.value;

  const charEL = document.querySelector('.product-embroidery_char span');

  if (checkboxWrapper) {
    if (text2Value) {
      checkboxWrapper.classList.remove('form-field__checkbox--disabled');
    } else {
      text1.checked = false;
      checkboxWrapper.classList.add('form-field__checkbox--disabled');
    }
  }

  if (charEL) charEL.innerHTML = text2Value.length;
  text1.value = text1.checked ? text2Value : '';
}

function handleInput() {
  const raw = text2.value;
  const sanitized = sanitizeEmbroideryText(raw);
  if (sanitized !== raw) {
    text2.value = sanitized;
  }
  if (hasDisallowedCharacters(raw)) {
    showInputError();
  }
  copyTextValue();
}

window.addEventListener('load', function () {
  handleInput();
});
